import { MenuItem as MUIMenuItem } from '@mui/material';
import React, { FC } from 'react';
import type { Transition } from '../../../../utils/statuses';
export interface MenuItemProps {
  changeStatus: { (value: any, transitionType?: string): void };
  disabled?: boolean;
  transition: Transition;
  transitionKey?: string;
}
const MenuItem: FC<MenuItemProps> = ({
  changeStatus,
  transition,
  disabled,
  transitionKey,
}): JSX.Element => (
  <MUIMenuItem
    data-testid={`action-${transition.label}`}
    disabled={disabled}
    onClick={() => {
      changeStatus(transition.to[0], transitionKey);
    }}
  >
    {transition.label}
  </MUIMenuItem>
);

export { MenuItem };
